import React, { useEffect } from 'react';
import ThemeProvider from 'components/v2/ThemeProvider';
import ItrvlAppBar from '../ItrvlAppBar';
import { useLocation } from 'react-router-dom';
import { sendGA4Pageview } from 'common/helpers/ga4';
import logger from 'itrvl-logger';
const log = logger(__filename);
log.trace(__filename);

const WrappedPageInner = ({ page: Page, useFixedAppbar, ...props }) => {
  return (
    <>
      <ItrvlAppBar useFixedAppbar={useFixedAppbar} />
      <Page {...props} />
    </>
  );
};

const usePageTracking = props => {
  const location = useLocation();

  useEffect(() => {
    sendGA4Pageview({
      page: location.pathname,
      contentGroup: props?.path,
    });
  }, [location, props]);
};

export default function WrappedPage(props) {
  //TODO - when v1 pages are refactored remove the v2 theme provider
  const MaybeTheme = props.useV1Theme ? EmptyComponent : ThemeProvider;
  usePageTracking(props);
  return (
    <MaybeTheme>
      <WrappedPageInner {...props} />
    </MaybeTheme>
  );
}

const EmptyComponent = ({ children }) => <>{children}</>;
